// extracted by mini-css-extract-plugin
module.exports = {"container":"natalAnalysis_container__1013t","title":"natalAnalysis_title__QYpBD","box":"natalAnalysis_box__1M1HY","insta":"natalAnalysis_insta__3vDDh"};